import { DATE_FORMAT } from '@/helpers/dates';
import { Button } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

import { DomesticContentEligibilityLabels, UserPermissions } from 'types';

import { useAccountDetailsContext } from './AccountDetailsContext';

interface UseITCAddersPropertiesParams {
  systemDesign: any;
  domesticContentEligibilityStatus: string;
  dcAttestmentType: string;
  canEnrollInDomesticContent: boolean;
  enrollInDomesticContentUi: boolean;
}

export function useITCAddersProperties({
  systemDesign,
  domesticContentEligibilityStatus,
  dcAttestmentType,
  canEnrollInDomesticContent,
  enrollInDomesticContentUi,
}: UseITCAddersPropertiesParams) {
  const { account, userPermissions, openModal } = useAccountDetailsContext();

  return {
    heading: 'ITC Adders',
    showInternalOnly: true,
    values: [
      {
        label: 'Domestic Content Eligibility',
        value: account?.itcAdderQualifications?.domesticContentEligible
          ? DomesticContentEligibilityLabels[
              domesticContentEligibilityStatus as keyof typeof DomesticContentEligibilityLabels
            ] + dcAttestmentType
          : '---',
      },
      {
        label: 'DC Value (PV)',
        value: systemDesign?.itcQualification?.result?.pvTotalPercentage
          ? `${systemDesign.itcQualification.result.pvTotalPercentage.toFixed(1)}%`
          : '---',
      },
      {
        label: 'DC Value (Storage)',
        value: systemDesign?.itcQualification?.result?.batteryPercentage
          ? `${systemDesign.itcQualification.result.batteryPercentage.toFixed(1)}%`
          : '---',
      },
      {
        label: 'EC Eligibility Check - Account Creation Date',
        value: account?.itcAdderQualifications?.potentialEligibilityQueryDate
          ? DateTime.fromISO(account?.itcAdderQualifications?.potentialEligibilityQueryDate)
              .toLocal()
              .toFormat(DATE_FORMAT)
          : '---',
      },
      {
        label: 'EC Eligibility - Account Creation',
        value: account?.itcAdderQualifications?.ecEligibilityAccountCreation ?? '---',
      },
      {
        label: 'EC Eligibility Check - QC Verified PTO Date',
        value: account?.itcAdderQualifications?.finalEligibilityQueryDate
          ? DateTime.fromISO(account?.itcAdderQualifications?.finalEligibilityQueryDate)
              .toLocal()
              .toFormat(DATE_FORMAT)
          : '---',
      },
      {
        label: 'EC Eligibility - QC Verified PTO',
        value: account?.itcAdderQualifications?.ecEligibilityPtoApproval ?? '---',
      },
      {
        label: 'EC Adder $ Eligible',
        value:
          account?.itcAdderQualifications?.ecBonusEligible !== undefined
            ? account.itcAdderQualifications.ecBonusEligible
              ? 'Eligible'
              : 'Not Eligible'
            : '---',
      },
      {
        label: 'Census Tract',
        value: account?.itcAdderQualifications?.ecFfeCountyMsaName ?? '---',
      },
      {
        label: 'MSA Code',
        value: account?.itcAdderQualifications?.ecFfeCountyMsaCode ?? '---',
      },
      ...(userPermissions.includes(UserPermissions.lightReachSupport) &&
      canEnrollInDomesticContent &&
      enrollInDomesticContentUi
        ? [
            {
              label: '',
              value: (
                <Button
                  variant="tertiary"
                  tone="primary"
                  size="xs"
                  onClick={() => openModal('enrollDomesticContent')}
                >
                  Enroll in Domestic Content
                </Button>
              ),
            },
          ]
        : []),
    ],
  };
}
